import { Button, Divider } from "@mui/material";
import { type FunctionComponent, type PropsWithChildren, type ReactNode } from "react";

import { ActionSection, DetailActionWrapper } from "./DetailAction.sc";

interface Props {
    onClick: () => void;
    icon?: ReactNode;
}
const DetailAction: FunctionComponent<PropsWithChildren<Props>> = ({ children, onClick, icon }) => (
    <DetailActionWrapper>
        <Divider />
        <ActionSection>
            <Button onClick={onClick} variant="text">
                {icon}
                {children}
            </Button>
        </ActionSection>
    </DetailActionWrapper>
);

export default DetailAction;
